<template>
    <section class="group vh100">
        <div class="group-course">
            <div class="group-course-image"
                :style="{ 'background-image': `url(${ groupData.teacher.image })` }"></div>
            <div class="group-course-info">
                <div class="group-course-info-title">{{ groupData.course.title }}</div>
                <div class="group-course-info-teacher">{{ groupData.teacher.name }}·{{ groupData.teacher.title }}</div>
                <div class="group-course-info-desc">{{ groupData.course.description }}</div>
                <div class="group-course-info-price">
                    <span>￥{{ groupData.course.price }}</span>
                    <span>￥{{ groupData.course.originalPrice }}</span>
                    <span>{{ groupData.course.subscribeCount }}人已订阅</span>
                </div>
            </div>
        </div>
        <div class="group-rule"
            v-if="groupData.status !== 1 && groupData.status !== 0">
            <div class="group-rule-title">拼课规则</div>
            <div class="group-rule-content">
                <p>自己先支付开团或选择即将成功的团直接参与。</p>
                <p>规定时间内人满拼团成功，人不满退款。</p>
            </div>
        </div>
        <div class="group-spliter"></div>
        <div class="group-time"
            v-if="groupData.status !== 1 && groupData.status !== 0">
            <div class="group-time-remain">
                还差<span>{{ successCount - groupData.userList.length }}</span>人成团
            </div>
            <div class="group-time-counter">
                还剩<span>{{ timeCounter.hours }}</span>时<span>{{ timeCounter.minutes }}</span>分<span>{{ timeCounter.seconds }}</span>秒
            </div>
        </div>
        <div v-else-if="groupData.status === 0">
          <img class="group-fail" src="../assets/images/group-fail.png" alt="拼团失败"/>
        </div>
        <div v-else>
            <div v-if="groupData.userInGroupStatus === 1" class="group-success">拼团成功</div>
            <div v-else class="group-full">拼团完成</div>
        </div>
        <div class="group-user-wrapper">
            <div class="group-user" :class="{ fail: true || groupData.status === 0 }">
                <div class="group-user-item"
                    :class="{ 'disable': isGroupDisable }"
                    v-for="(user, index) in userGroup"
                    :key="index">
                    <div class="group-user-item-image"
                        v-if="user"
                        :style="{ 'background-image': `url(${ user.pic })` }"
                        :class="{ 'has-tag': user.userId === groupData.creatorUserId, 'disable': isGroupDisable }" />
                </div>
            </div>
        </div>
        <div class="group-button">
            <div class="group-button-tip"
                v-if="groupData.status !== 1">好课要分享，邀朋友助力快速成团！</div>

            <div class="group-button-trigger"
                :class="{ 'disable': isGroupDisable }"
                @click="handleClickButton">{{ buttonText }}</div>
        </div>
        <screen-wrapper
            v-if="isShareVisible"
            :top="30"
            @close="() => isShareVisible = false">
            <div class="group-share">
                <p>点击右上角，好课要分享</p>
                <p>邀朋友助力快速成团！</p>
            </div>
        </screen-wrapper>
        <screen-wrapper
            v-if="isPayVisible"
            @close="() => isPayVisible = false">
            <div class="group-pay">
                <p><b>此课程已拼</b></p>
                <p>快看看其他拼团课程吧！</p>
                <div class="group-pay-button"
                    @click="handleNavigate('/recommend')">查看更多课程</div>
            </div>
        </screen-wrapper>
        <screen-wrapper
            v-if="isFullVisible"
            @close="() => isFullVisible = false">
            <div class="group-pay">
                <p><b>此拼课人数已满</b></p>
                <p>您可再开一团！</p>
                <div class="group-pay-button"
                    @click="handleNavigate('/sign-up', true)">再开一团</div>
            </div>
        </screen-wrapper>
    </section>
</template>

<script>
    /** eslint-disable */
    import api from '@edu-fe/api'
    import Pay from '@edu-fe/pay'
    import ScreenWrapper from '../components/ScreenWrapper.vue'
    import ShareMaker from '../lib/shareMaker'
    import fixNumber from '../filters/fixed-number'

    export default {
        name: 'Group',
        components: {
            ScreenWrapper
        },
        data() {
            return {
                /**
                 * 拼团信息
                 * userInGroupStatus 用户参团状态
                 * @value
                 * -1: 已购买该课程
                 * 0: 未参团
                 * 1: 已参加本团
                 * 2: 已参加该课程其他团
                 * status 拼团状态
                 * @value
                 * 0: 失败
                 * 1: 成功
                 * 2: 拼团中
                 */
                groupData: {
                    course: {},
                    teacher: {},
                    userList: []
                },
                successCount: 0, // 成团人数
                remainTime: 0, // 拼团结束剩余时间
                userGroup: [], // 拼团成员
                timer: null, // 倒计时对象
                isShareVisible: false, // 分享弹窗
                isPayVisible: false, // 支付完成弹窗
                isFullVisible: false // 人数已满提醒
            }
        },
        computed: {
            timeCounter() {
                const totalSeconds = parseInt(this.remainTime / 1000)
                const hours = parseInt(totalSeconds / 3600)
                const minutes = parseInt((totalSeconds - 3600 * hours) / 60)
                const seconds = totalSeconds - hours * 3600 - minutes * 60
                return {
                    hours: hours || 0,
                    minutes: minutes || 0,
                    seconds: seconds || 0
                }
            },
            buttonText() {
                let text = ''

                const { status, userInGroupStatus } = this.groupData
                if(userInGroupStatus === 0) {
                    if(status === 1) {
                        text = '再开一团'
                    } else {
                        text = '参与拼课'
                    }
                } else if(userInGroupStatus === 2) {
                    text = '此课程已拼'
                } else if(userInGroupStatus === 1) {
                    const map = ['再开一团', '马上学习', '邀请好友拼课']
                    text = map[status]
                } else {
                    text = '已购买该课程'
                }

                return text
            },
            isGroupDisable() {
                const map = [ '此课程已拼' ]
                return map.indexOf(this.buttonText) !== -1
            }
        },
        created() {
            this.getData()
        },
        beforeDestroy() {
            window.clearInterval(this.timer)
            this.timer = null
        },
        methods: {
            getData() {
                api.group.getGroupData({
                    id: this.$route.query.groupId,
                    shareUserId: this.$route.query.shareUserId
                }).then(res => {
                    this.groupData = res.data
                    this.successCount = this.groupData.successCount
                    this.remainTime = this.groupData.endTime - this.groupData.systemDate

                    // 补全空余的userList
                    this.userGroup = this.groupData.userList.concat(Array.from({ length: this.successCount - this.groupData.userList.length }))

                    // 创建倒计时
                    clearInterval(this.timer)
                    this.timer = setInterval(() => {
                        if(this.remainTime <= 0) {
                            this.getData()
                            clearInterval(this.timer)
                        } else {
                            this.remainTime -= 1000
                        }
                    }, 1000)

                    // 用户已参加该课程其他团
                    if(this.groupData.userInGroupStatus === 2 || this.groupData.userInGroupStatus === -1) {
                        this.isPayVisible = true
                    }

                    // 配置分享信息
                    const price = fixNumber(this.groupData.course.originalPrice - this.groupData.course.price, 2)
                    new ShareMaker({
                        title: `掐指一算，团里缺你！ ${ this.successCount }人成团，立减${ price }元!`,
                        introduction: `亲爱的朋友，邀您一起学习精品好课《${ this.groupData.course.title }》`,
                        imgUrl: 'http://cdn.iciba.com/www/edu_m/share/group-icon-share.png',
                        link: `https://course-m.auoktalk.com/group?groupId=${ this.$route.query.groupId }&shareUserId=${ this.groupData.shareUserId }`
                    }, location.href, true)
                })
            },
            handleNavigate(url, withCourseId) {
                if (withCourseId) {
                  this.$router.push(url + '?courseId=' + this.groupData.course.courseId)
                } else {
                  this.$router.push(url)
                }
            },
            handleClickButton() {
                const { status, userInGroupStatus } = this.groupData
                const { groupCourseId, courseId } = this.groupData.course
                const groupId = this.$route.query.groupId

                if(userInGroupStatus === 0) {
                    if(status !== 1) {
                        // 判断是否拼课人数已满
                        api.group.getGroupData({
                            id: this.$route.query.groupId
                        }).then(res => {
                            const { successCount, userList } = res.data
                            if(successCount === userList.length) {
                                this.isFullVisible = true
                            } else {
                                new Pay({
                                    type: 7,
                                    courseId: groupCourseId,
                                    groupId: groupId,
                                    from: this.$route.query.from,
                                    payWay: 10,
                                    price: this.groupData.course.price,
                                    payment: true,
                                    gotoResult: () => {
                                        api.group.isSubsribe().then(res => {
                                            if(res.data === 0) { // 未关注公众号
                                                this.handleNavigate(`/group-result?groupId=${ groupId }`)
                                            } else {
                                                this.getData()
                                            }
                                        })
                                    }
                                })
                            }
                        })
                    } else {
                        this.handleNavigate(`/recommend`)
                    }
                } else if(userInGroupStatus === 2) {
                        // this.handleNavigate(`/recommend`)
                } else if(userInGroupStatus === 1) {
                    if(status === 0) {
                        this.handleNavigate(`/sign-up`, true)
                    } else if(status === 1) {
                        this.handleNavigate(`/schedule?courseId=${ courseId }`)
                    } else {
                        this.isShareVisible = true
                    }
                } else {
                    this.handleNavigate(`/schedule?courseId=${ courseId }`)
                }

            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../style/main';

    .group {
        overflow-y: scroll;
        /*height: 100%;*/
        font-family: PingFangSC-Regular;

        &-fail {
          display: block;
          height: rem(138);
          width: rem(499);
          margin: 0 auto;
          margin-top: rem(108);
        }

        &-course {
            display: flex;
            margin-left: rem(30);
            padding: rem(36) 0;

            &-image {
                margin-right: rem(30);
                width: rem(155);
                height: rem(190);
                border-radius: 4px;
                // background-image: url('../assets/images/avatar-example.jpg');
                background-size: contain;
                background-repeat: no-repeat;
            }

            &-info {
                flex: 1;

                &-title {
                    font-size: rem(30);
                    color: #333;
                }

                &-teacher {
                    margin: rem(20) 0;
                    font-size: rem(24);
                    color: #666;
                }

                &-desc {
                    overflow: hidden;
                    width: rem(420);
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    font-size: rem(24);
                    color: #999;
                }

                &-price {
                    transform: scale(.9);
                    transform-origin: 0 0;
                    margin-top: rem(30);

                    & > span {
                        display: inline-block;
                        vertical-align: middle;

                        &:first-child {
                            $red: #ed4040;
                            $h: rem(30);

                            // box-sizing: border-box;
                            padding: 0 rem(5) 0 rem(60);
                            height: $h;
                            line-height: 1.4;
                            // line-height: $h;
                            border: 1px solid $red;
                            background-color: #ffeaea;
                            font-size: rem(24);
                            color: $red;

                            &::before {
                                content: '拼课';
                                box-sizing: border-box;
                                transform: translateY(-50%);
                                position: absolute;
                                top: 50%;
                                left: 0;
                                padding: 0 rem(5);
                                width: rem(60);
                                height: 100%;
                                line-height: 1.5;
                                background-color: $red;
                                text-align: center;
                                font-size: rem(24);
                                color: #fff;
                            }
                        }

                        &:nth-child(2) {
                            margin: 0 rem(10);
                            font-size: rem(30);
                            color: #f48f00;
                        }

                        &:last-child {
                            padding-left: rem(10);
                            border-left: 1px solid #999;
                            font-size: rem(30);
                            color: #999;
                        }
                    }
                }
            }
        }

        /** course end **/

        &-rule {
            display: flex;
            margin-left: rem(30);
            padding: rem(30) rem(30) rem(30) 0;
            line-height: 1.5;
            border-top: 1px solid #e4e4e4;
            font-size: rem(24);

            &-title {
                padding-right: rem(30);
                color: #999;
            }

            &-content {
                flex: 1;
            }
        }

        &-spliter {
            height: rem(20);
            background-color: #f3f4f6;
        }

        /** rule end **/

        &-time {
            padding: rem(40) 0 rem(76);
            text-align: center;

            &-remain {
                font-size: rem(54);
                color: #333;

                & > span {
                    padding: rem(10);
                    color: #f48f00;
                }
            }

            &-counter {
                margin-top: rem(30);
                line-height: rem(54);
                font-size: rem(30);
                color: #999;

                & > span {
                    display: inline-block;
                    margin: 0 rem(10);
                    width: rem(80);
                    height: rem(54);
                    border-radius: 3px;
                    background-color: #666;
                    color: #fff;
                }
            }
        }

        /** time end **/

        &-success {
            margin: rem(120) auto 0;
            width: rem(580);
            height: rem(220);
            background: {
                image: url('../assets/images/group-success-bg.png');
                size: cover;
            }
            text-align: center;
            font-size: rem(54);
            color: #333;

            &::after {
                content: '感谢各位好友鼎力相助，一起进步！';
                display: block;
                margin-top: rem(40);
                font-size: rem(30);
                color: #999;
            }
        }

        &-full {
            margin: rem(120) auto 0;
            width: rem(580);
            height: rem(220);
            text-align: center;
            font-size: rem(54);
            color: #999;

            &::after {
                content: '此拼课人数已满，您可再开一团';
                display: block;
                margin-top: rem(40);
                font-size: rem(30);
            }
        }

        &-user {
            margin: 0 auto rem(90);
            width: rem(388);

            &.fail {
              margin-top: rem(40);
            }

            &-item {
                $size: rem(100);

                display: inline-block;
                box-sizing: border-box;
                position: relative;
                margin-bottom: rem(25);
                width: $size;
                height: $size;
                border: 1px dashed #979797;
                border-radius: 50%;
                background: {
                    image: url('../assets/images/group-icon-question.png');
                    size: rem(20) rem(30);
                    repeat: no-repeat;
                    position: center;
                    color: #fafafa;
                }

                &:not(:nth-child(3n - 2)) {
                    margin-left: rem(44);
                }

                &-image {
                    box-sizing: border-box;
                    transform: translate(-50%, -50%);
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    width: $size + rem(5);
                    height: $size + rem(5);
                    border: 2px solid #f48f00;
                    border-radius: 50%;
                    background: {
                        image: url('../assets/images/avatar-example.jpg');
                        size: cover;
                    }

                    &.has-tag {
                        &::before {
                            content: '团长';
                            transform: translateX(-50%);
                            position: absolute;
                            bottom: rem(-10);
                            left: 50%;
                            padding: rem(5);
                            width: rem(80);
                            border-radius: rem(30);
                            background-color: #f48f00;
                            text-align: center;
                            font-size: rem(20);
                            color: #fff;
                        }
                    }

                    &.disable {
                        border: 2px solid #999;

                        &::before {
                            background-color: #999;
                        }
                    }
                }
            }
        }

        /** user end **/

        &-button {
            text-align: center;

            &-tip {
                font-size: rem(30);
                color: #999;
            }

            &-trigger {
                margin: rem(38) auto rem(52);
                padding: rem(25);
                width: rem(620);
                border-radius: 3px;
                background-image: linear-gradient(to right, #ff5d00, #f44b00);
                font-size: rem(34);
                color: #fff;

                &.disable {
                    background-image: none;
                    background-color: #eee;
                }
            }
        }

        /** button end **/

        &-share {
            padding-top: rem(480);
            width: rem(560);
            line-height: 1.5;
            background: {
                image: url('../assets/images/group-share-bg.png');
                size: contain;
                position: center top;
                repeat: no-repeat;
            }
            text-align: center;
            font-size: rem(36);
            color: #fff;
        }

        &-pay {
            padding: rem(90) 0 rem(50);
            width: rem(600);
            border-radius: 3px;
            background-color: #fff;
            text-align: center;

            &::before {
                content: '';
                display: block;
                margin: 0 auto;
                width: rem(122);
                height: rem(146);
                background: {
                    image: url('../assets/images/group-icon-pay.png');
                    size: contain;
                    repeat: no-repeat;
                }
            }

            & > p {
                font-size: rem(34);
                color: #333;

                &:first-child {
                    margin: rem(108) 0 rem(40);
                }
            }

            &-button {
                margin: rem(140) auto 0;
                padding: rem(24) 0;
                width: rem(460);
                border-radius: 4px;
                background-image: linear-gradient(to right, #ffb500, #f48f00);
                font-size: rem(34);
                color: #fff;
            }
        }
    }
</style>
